import React from "react";
import "./contactUs.css";

export default function ContactUs() {
  return (
    <section id="ContactUs" className="contactUs">
      <div className="contactContent">
        <div className="contactHead">
          <h1>
            Contact Us
            <img src="./images/Vector.png" alt="Vector"></img>
          </h1>
          <p>
            At Pristine PV, we specialize in professional PV panel cleaning for
            homes and businesses. We know dirty solar panels cut energy output.
            That's why our trained team uses safe, eco-friendly methods to
            restore your panels' efficiency. We're committed to reliable service
            and helping you maximize your solar investment.
          </p>
        </div>
        <div className="contactInfo">
          <div className="contactInfoBox">
            <i className="bi bi-telephone-fill"></i>
            <div className="infoContent">
              <h6>+44 7853 278866</h6>
            </div>
          </div>
          <div className="contactInfoBox">
            <i className="bi bi-envelope-fill"></i>
            <div className="infoContent">
              <h6>info@pristinepv.co.uk</h6>
              {/* <h6>babar@pristinepv.co.uk</h6> */}
              {/* <h6>nasra@pristinepv.co.uk</h6> */}
            </div>
          </div>
          <div className="contactInfoBox">
            <i className="bi bi-geo-alt-fill"></i>
            <div className="infoContent">
              <h6>
                St. Peters Chambers, 2-4 Primitive Street, Huddersfield, United
                Kingdom, HD1 1QZ
              </h6>
            </div>
          </div>
        </div>
        <div className="copyRights">
          <hr></hr>
          <h6>© Copyright 2023, All Rights Reserved by Pristine PV</h6>
        </div>
      </div>
    </section>
  );
}
